import { createFileRoute } from "@tanstack/react-router";
import { ParkingScreen } from "../screens/ParkingScreen";

export const Route = createFileRoute("/parking")({
  component: ParkingScreen,
});
